import React, {useState} from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FileMetaDataTabUserLabels.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import EventEmitter from 'events';
import {FileMetaDataDialog_changeUserLabels} from '../../../init/events';
import {LabelPicker} from '../../LabelPicker/LabelPicker';
import {LabelDTO} from '../../../models/dto/LabelDTO';
import {TemplatePropertySettings} from '../../../models/TemplatePropertySettings';
import {isMandatoryComponent, isVisibleComponent} from '../../../utils/TemplateUtils';
import {
    STORAGE_OBJECT_OBJECT_METADATA,
    STORAGE_OBJECT_OBJECT_METADATA_USER_LABELS
} from '../../../init/storage_object_constants';
import {config} from '../../../init/config';
import {isValidStringArray} from '../../../utils';
import {Valid} from '../../validation/Valid';

export interface FileMetaDataTabUserLabelsProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly dataSource: LabelDTO[];
    readonly userLabels?: string[];
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FileMetaDataTabUserLabels
 * @description
 * The dialog to add the metadata of a newly created file or edited file - Metadata Tabs
 */
export const FileMetaDataTabUserLabels: React.VFC<FileMetaDataTabUserLabelsProps> = (props) => {
    const [userLabelsInput, setUserLabelsInput] = useState<string[]>(props.userLabels ?? []);

    const handleChangeUserLabel = (userLabels: string[]) => {
        setUserLabelsInput(userLabels);
        props.eventEmitter.emit(FileMetaDataDialog_changeUserLabels, userLabels);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            {(config.LABEL_ENABLED && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                    && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_USER_LABELS, props.templatePropertySettings)) &&
                <Accordion accordionHeadline={t('UPLOAD_FILE_META_DATA_DIALOG_ACCORDION_LABEL')}
                           startOpen>
                    <Valid
                        isValid={(isMandatoryComponent(STORAGE_OBJECT_OBJECT_METADATA_USER_LABELS, props.templatePropertySettings) ? isValidStringArray(userLabelsInput) : true)}
                        message={t('ERROR_USER_LABELS_MISSING')}>
                        <LabelPicker dataSource={props.dataSource}
                                     userLabels={userLabelsInput}
                                     onChange={handleChangeUserLabel}/>
                    </Valid>
                </Accordion>
            }
        </ContentWrapper>
    );
}